<template>
  <div class="hello">
    <ul>
      <li v-for="(step, index) in steps">
        <a v-if="!step.isOption" target="_blank" :href="step.url">
          <span class="index"> {{ index + 1}} </span>
          {{ step.title }}
        </a>

        <router-link v-if="step.isOption" :to="{ name: 'Option', params: { id: step.id } }">
          <span class="index"> {{ index + 1}} </span>
          {{ step.title }}
          <span class="go-icon">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </span>
        </router-link>
      </li>

      <li v-if="information" class="information">
        <p v-html="information">
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Option',
  data() {
    return {
      information: false,
      steps: [],
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route() {
      this.fetchData();
    },
  },
  methods: {
    fetchData() {
      if (this.$route.params.id == 1) {
        this.steps = [
          {
            title: 'Teknik Destek Almak İstiyorum ',
            id: 3,
            isOption: true,
          },
          {
            title: 'Fatura İşlemleri',
            id: 4,
            isOption: true,
          },
          {
            title: 'Nakil İşlemleri',
            id: 5,
            isOption: true,
          },
          {
            title: 'Aktivasyonum Hakkında Bilgi Almak İstiyorum',
            id: 6,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Aktivasyonum Hakkında Bilgi Almak İstiyorum',
          },
          {
            title: 'Tarife İşlemleri',
            id: 7,
            isOption: true,
          },
          {
            title: 'Modem satın almak istiyorum',
            id: 8,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Modem satın almak istiyorum',
          },
          {
            title: 'Diğer',
            id: 9,
            isOption: true,
          },
        ];
      }

      if (this.$route.params.id == 4) {
        this.steps = [
          {
            title: 'Ödenmemiş Faturalar Hakkında Bilgi Almak İstiyorum',
            id: 10,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Ödenmemiş Faturalar Hakkında Bilgi Almak İstiyorum',
          },
          {
            title: 'Ödeme Kanalları Hakkında Bilgi Almak istiyorum',
            id: 11,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Ödeme Kanalları Hakkında Bilgi Almak istiyorum',
          },
          {
            title: 'Cayma Bedelimi Öğrenmek İstiyorum',
            id: 12,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Cayma Bedelimi Öğrenmek İstiyorum',
          },
          {
            title: 'Fatura Kesim Tarihini Öğrenmek İstiyorum',
            id: 13,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Fatura Kesim Tarihini Öğrenmek İstiyorum',
          },
          {
            title: 'Fatura Şikayeti',
            id: 14,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Fatura Şikayeti',
          },
          {
            title: 'Diğer',
            id: 15,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Diğer',
          },
        ];
      }

      if (this.$route.params.id == 3) {
        this.steps = [
          {
            title: 'Hız Problemi',
            id: 16,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / Hız Problemi',
          },
          {
            title: 'Sık Kopma Problemi',
            id: 17,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / Sık Kopma Problemi',
          },
          {
            title: 'İnternete Giremiyorum',
            id: 18,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / İnternete Giremiyorum',
          },
          {
            title: 'Modem Kurulumu',
            id: 19,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / Modem Kurulumu',
          },
          {
            title: 'Diğer',
            id: 20,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / Diğer',
          },
        ];
      }
      if (this.$route.params.id == 5) {
        this.steps = [
          {
            title: 'Nakil Başlatmak İstiyorum',
            id: 21,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Nakil İşlemleri / Nakil Başlatmak İstiyorum',
          },
          {
            title: 'Nakil Başvurumun Durumunu Öğrenmek İstiyorum',
            id: 22,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Nakil İşlemleri / Nakil Başvurumun Durumunu Öğrenmek İstiyorum',
          },
        ];
      }
      if (this.$route.params.id == 7) {
        this.steps = [
          {
            title: 'Tarife / Taahhüt Bilgilerimi Öğrenmek İstiyorum',
            id: 23,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Tarife İşlemleri / Tarife / Taahhüt Bilgilerimi Öğrenmek İstiyorum',
          },
          {
            title: 'Tarifemi değiştirmek istiyorum',
            id: 24,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Tarife İşlemleri / Tarifemi değiştirmek istiyorum',
          },
        ];
      }
      if (this.$route.params.id == 9) {
        this.steps = [
          {
            title: 'Müşteri Numaramı Öğrenmek İstiyorum',
            id: 25,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Diğer / Müşteri Numaramı Öğrenmek İstiyorum',
          },
          {
            title: 'Bilgilerimi Güncellemek İstiyorum',
            id: 26,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Diğer / Bilgilerimi Güncellemek İstiyorum',
          },
          {
            title: 'Online İşlemlere Giriş Yapmak İstiyorum',
            id: 27,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Diğer / Online İşlemlere Giriş Yapmak İstiyorum',
          },
          {
            title: 'Diğer',
            id: 28,
            isOption: false,
            url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Diğer / Diğer',
          },
        ];
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
    padding-top: 20px;
    width: 100%;
    margin: 0;
    max-height: 570px;
    overflow-y: hidden;
  }

  li {
    display: block;
    text-align: left;
    padding: 0 15px;

    a {
      border-top: 5px solid rgba(255, 255, 255, 0);
      border-bottom: 5px solid rgba(255, 255, 255, 0);
      margin-top: -5px;
      margin-bottom: -5px;
    }

    a:active {
        background:  rgba(255, 255, 255, 0) !important;
      }

    &::after {
      content: '';
      width: 100%;
      background-color: #E0E0E0;
      opacity: 0.6;
      height: 1px;
      display: block;
      margin: 15px auto;
    }

    &.information {
      font-size: 13px;
      color: #8e8e8e;
    }
  }

  .not-these {
    text-decoration: none;
    display: block;
    clear: both;
    margin: 20px auto;
    width: 85%;
    box-sizing: border-box;
    padding: 15px 20px;
    text-align: left;
    font-size: 14px;
    background: #3586ad;
    color: #fff;
    border-radius: 4px;
    box-shadow: 0px 5px 20px 0 rgba(0, 0, 0, 0.2);

    i {
      float: right;
    }
  }

  li a {
    font-size: 14px;
    color: #858484;
    letter-spacing: 0;
    line-height: 20px;
    text-decoration: none;
    display: block;
    position: relative;
    padding: 0 25px;

    &:hover {
      .go-icon {
        right: 5px;
        opacity: 1;
      }
    }

    .index {
      position: absolute;
      opacity: 0.4;
      font-size: 19px;
      color: #858484;
      left: 0;
      transition: all 0.5s;
    }

    .go-icon {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      transition: all 0.5s;
      font-size: 13px;
      opacity: 0.6;
    }
  }
</style>



// WEBPACK FOOTER //
// Option.vue?55fbd068